module.exports = __webpack_public_path__ + "static/media/avatar.d2d605a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/avatar.png
// module id = ./src/assets/icons/avatar.png
// module chunks = 0